module.exports = __webpack_public_path__ + "static/img/news.6f681a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news.jpg
// module id = Dx42
// module chunks = 1